import React, { Component } from 'react';
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    IconButton,
    InputAdornment,
    Stack,
    Link,
    Avatar,
    Divider
} from '@mui/material';
import {
    Visibility,
    VisibilityOff,
    Close as CloseIcon,
} from "@mui/icons-material";
import { CartContext } from "../../comp/CartContext";
import { WithRouter } from '../../comp/WithRouter';

class Registrar extends Component {
    static contextType = CartContext;

    constructor(props) {
        super(props);
        this.state = {
            color: '#1976d2',
            nome: '',
            cpf: '',
            telefone: '',
            email: '',
            senha: '',
            confirmarSenha: '',
            showPassword: false,
            showConfirmPassword: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        const { data } = this.context || {};
        if (data?.color) {
            this.setState({ color: data.color });
        }
    }

    handleChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    toggleVisibility = (field) => {
        this.setState((prevState) => ({
            [field]: !prevState[field]
        }));
    }

    handleSubmit(event) {
        event.preventDefault();
        const { nome, cpf, telefone, email, senha, confirmarSenha } = this.state;

        if (senha !== confirmarSenha) {
            alert("As senhas não coincidem!");
            return;
        }

        // Lógica de registro aqui (API call)
        console.log('Dados de Registro:', { nome, cpf, telefone, email, senha });
    }

    render() {
        const store = this.context?.data || {};
        const {
            color, nome, cpf, telefone, email, senha,
            confirmarSenha, showPassword, showConfirmPassword
        } = this.state;

        return (
            <Container maxWidth="xs" sx={{ minHeight: "100vh", bgcolor: "#f9f9f9", py: 4 }}>
                <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 3, boxShadow: 2 }}>

                    {/* Cabeçalho identico ao login */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Avatar
                                src={`/api/store/photo/${store.logo}`}
                                sx={{ width: 40, height: 40, bgcolor: color }}
                            >
                                {store.name?.charAt(0)}
                            </Avatar>
                            <Typography variant="h6" sx={{ fontWeight: 700 }}>{store.name}</Typography>
                        </Box>
                        <IconButton onClick={() => this.props.navigate(-1)}><CloseIcon /></IconButton>
                    </Box>

                    <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>Criar conta</Typography>

                    <Stack component="form" onSubmit={this.handleSubmit} spacing={2}>
                        <TextField
                            fullWidth
                            label="Nome completo"
                            name="nome"
                            value={nome}
                            onChange={this.handleChange}
                            required
                        />

                        <TextField
                            fullWidth
                            label="CPF"
                            name="cpf"
                            value={cpf}
                            onChange={this.handleChange}
                            required
                        />

                        <TextField
                            fullWidth
                            label="Telefone"
                            name="telefone"
                            value={telefone}
                            onChange={this.handleChange}
                            required
                        />

                        <TextField
                            fullWidth
                            label="E-mail"
                            name="email"
                            type="email"
                            value={email}
                            onChange={this.handleChange}
                            required
                        />

                        <TextField
                            fullWidth
                            label="Senha"
                            name="senha"
                            type={showPassword ? 'text' : 'password'}
                            value={senha}
                            onChange={this.handleChange}
                            required
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => this.toggleVisibility('showPassword')} edge="end">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <TextField
                            fullWidth
                            label="Confirmar Senha"
                            name="confirmarSenha"
                            type={showConfirmPassword ? 'text' : 'password'}
                            value={confirmarSenha}
                            onChange={this.handleChange}
                            required
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => this.toggleVisibility('showConfirmPassword')} edge="end">
                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            size="large"
                            sx={{ bgcolor: color, mt: 2, py: 1.5, borderRadius: 2, '&:hover': { bgcolor: color, opacity: 0.9 } }}
                        >
                            Cadastrar
                        </Button>
                    </Stack>

                    <Divider sx={{ my: 3 }}>ou</Divider>

                    <Box textAlign="center">
                        <Typography variant="body2" sx={{ color: '#7f8c8d' }}>
                            Já tem uma conta?{' '}
                            <Link
                                component="button"
                                variant="body2"
                                onClick={() => this.props.navigate('/conta')}
                                sx={{ color: color, fontWeight: 600, textDecoration: 'none' }}
                            >
                                Fazer Login
                            </Link>
                        </Typography>
                    </Box>
                </Box>
            </Container>
        );
    }
}

export default WithRouter(Registrar);